import { toUpper, snakeCase, isNil } from 'lodash';

export default function parseDeployedIntegrations({ deployedIntegrations, pipelineIntegrations, integrationsData }) {
  return deployedIntegrations.map(deployedIntegration => {
    const stagedRevisions = pipelineIntegrations.map(pipelineIntegration => pipelineIntegration.stagedRevision);
    const stagedRevision = stagedRevisions.find(
      stagedRevision => stagedRevision?.id === deployedIntegration?.revision?.id
    );
    const integrationData = integrationsData.find(
      integration => integration.id === stagedRevision?.playbook.integration.id
    );
    const stagedPlaybook = integrationData?.playbooks.find(
      playbook => playbook.revision === stagedRevision?.playbook.revision
    );

    const pipelineVars = {};
    stagedPlaybook?.pipeline_variables.forEach(pipelineVariable => {
      const endpointSchemaParam = deployedIntegration.endpointSchema?.params?.find(
        param => param.name === pipelineVariable.name
      );
      const connectionParam = deployedIntegration.connection?.params?.find(
        param => param.name === toUpper(snakeCase(pipelineVariable.name))
      );
      const transformStageParam = deployedIntegration.transformStages[0]?.data?.playbook?.params?.find(
        param => param.name === pipelineVariable.name
      );

      if (endpointSchemaParam) {
        pipelineVars[pipelineVariable.name] = endpointSchemaParam.defaultValue;
      }
      if (connectionParam) {
        pipelineVars[pipelineVariable.name] = connectionParam.defaultValue;
      }
      if (transformStageParam) {
        pipelineVars[pipelineVariable.name] = transformStageParam.defaultValue;
      }
    });

    const integration = integrationsData.find(integrationData => integrationData.id === deployedIntegration.id);

    // Determine "CLI Managed" here by the inability to find an associated Ion Pipeline Integration record
    const cliManaged = isNil(stagedRevision);

    /*
      Tech Debt - ND - The deployed revision initiated via the CLI may not have a lot of the fields that an Ion
      would populate. The excessive use of `?` is a band-aid. we should holistically update the codebase
      to allow for heterogeneous data / lots of optional fields.
     */
    const id = stagedRevision?.id ?? deployedIntegration.revision?.id ?? null;
    const revision = deployedIntegration.transformStages?.[0]?.data.playbook.version;
    const deployed = {
      integrationId: deployedIntegration.id,
      id,
      revision: revision ? Number(revision) : null,
      stagedForDelete: false,
      pipelineVars: pipelineVars,
      starterkitId: deployedIntegration.integrationName,
      integration,
      disabled: deployedIntegration.disabled,
      cliManaged,
    };
    if (deployedIntegration.consent) {
      deployed.consent = deployedIntegration.consent;
    }

    if (cliManaged) {
      deployed.deployedIntegrationJson = deployedIntegration;
    }

    return deployed;
  });
}
